export const getFirstItemFromQuery = (query) => {
    return query.edges[0].node;
}